import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Grid, Typography } from '@mui/material';

import { useAmenities } from '@/hooks/useAmenities';

import { AmenitiesLevel } from '@/components/amenitiesLevel/AmenitiesLevel';
import { amenitiesToForm, formToAmenities } from '@/components/amenitiesLevel/utils';
import { Loader } from '@/components/Loader';
import { GenericModalFooter } from '@/components/modal/GenericModalFooter';
import type { TStepComponentProps } from '@/components/stepper/types';

import type { TCreateStationForm } from '@/types/station';

import { styles as formStyles } from '../Form.styles';

export const StationAmenities = ({
  data: { amenities },
  moveBack,
  onSubmit,
}: TStepComponentProps<TCreateStationForm>) => {
  const { t } = useTranslation();
  const { loading, options } = useAmenities();

  const [data, setData] = useState(() => amenitiesToForm(amenities));

  const setValue = (prop: string, value: boolean) => {
    setData((prev: Record<string, boolean>) => ({ ...prev, [prop]: value }));
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    onSubmit({
      amenities: formToAmenities(data, options),
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={formStyles.form}>
      <Loader active={loading} position="absolute" />

      <Box sx={formStyles.content}>
        <Typography variant="h6" sx={formStyles.title}>
          {t('stationSetup.stationAmenities.title')}
        </Typography>

        <Grid spacing={4} container>
          <AmenitiesLevel items={options} values={data} setValue={setValue} xs={12} />
        </Grid>
      </Box>

      <GenericModalFooter sx={formStyles.footer} squareButtons>
        <Box sx={formStyles.controls}>
          <Button variant="outlined" onClick={moveBack}>
            {t('common.back')}
          </Button>

          <Button type="submit">{t('common.next')}</Button>
        </Box>
      </GenericModalFooter>
    </Box>
  );
};
